import React from "react";
import CurrentOpeningFormPage from "../components/career/CurrentOpeningFormPage";

const CareerCurrentOpeningCreate = () => <CurrentOpeningFormPage mode="create" />;

export default CareerCurrentOpeningCreate;
